// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e94aa9b0","977":"a813c71c"}[chunkId] + ".chunk.js";
};